import React from 'react'
import { makeStyles, Typography } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'
import type { ColorTileProps } from './ColorTile'

const useStyles = makeStyles<Theme, ColorTileProps>(
  (theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'row'
    },
    colorSquare: {
      width: '40px',
      height: '40px',
      border: '2px solid #71716d',
      borderRadius: theme.shape.borderRadius
    },
    textContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      paddingLeft: '12px'
    },
    colorCode: {
      color: '#2f2f30',
      fontFamily: 'CustomFont-SW',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '16px',
      letterSpacing: '-0.25px'
    },
    colorName: {
      color: '#2f2f30',
      fontFamily: 'CustomFont-SW',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '16px',
      letterSpacing: '-0.25px'
    }
  }),
  { name: 'MobileColorTile' }
)

function MobileColorTile(props: ColorTileProps) {
  const { color, colorCode, colorName, style } = props
  const classes = useStyles(props)

  return (
    <div className={classes.root}>
      <div className={classes.colorSquare} style={{ background: color, ...style }} />

      <div className={classes.textContainer}>
        <Typography className={classes.colorName} variant="body1" weight={'bold'}>
          {colorName}
        </Typography>
        <Typography className={classes.colorCode} variant="body1">{`SW ${colorCode}`}</Typography>
      </div>
    </div>
  )
}

export default MobileColorTile
